var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/heroicons-solid/arrow-left-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.75C11.0254 3.75 3.75 11.0254 3.75 20C3.75 28.9746 11.0254 36.25 20 36.25C28.9746 36.25 36.25 28.9746 36.25 20C36.25 11.0254 28.9746 3.75 20 3.75ZM12.8661 19.1161C12.6317 19.3505 12.5 19.6685 12.5 20C12.5 20.3315 12.6317 20.6495 12.8661 20.8839L17.8661 25.8839C18.3543 26.372 19.1457 26.372 19.6339 25.8839C20.122 25.3957 20.122 24.6043 19.6339 24.1161L16.7678 21.25H26.25C26.9404 21.25 27.5 20.6904 27.5 20C27.5 19.3096 26.9404 18.75 26.25 18.75L16.7678 18.75L19.6339 15.8839C20.122 15.3957 20.122 14.6043 19.6339 14.1161C19.1457 13.628 18.3543 13.628 17.8661 14.1161L12.8661 19.1161Z",
    fill: "#3B3C45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.d814d3336e55dc35bea4b974558f108e.svg";
export { ForwardRef as ReactComponent };